import React, { useState } from "react";
import { storage } from "../firebase";
import { toast } from "react-toastify";
import { CircularProgress, LinearProgress } from "@material-ui/core";
import { Picker, emojiIndex } from "emoji-mart";
import "emoji-mart/css/emoji-mart.css";
import EmojiIcon from "../assets/emoji.png";

const CreateMessage = ({ send, read, chatIndex, userIsTyping, user }) => {
  const [text, setText] = useState("");
  const [image, setImage] = useState(null);
  const [progress, setProgress] = useState(0);
  const [emojiPicker, showEmojiPicker] = useState(false);

  const tooltip = (t) => {
    return <span>{t}</span>;
  };

  const notification = (text) => {
    const raisetoast = (
      <p style={{ fontWeight: "700", color: "Black", fontSize: "1.4rem" }}>
        {text}
      </p>
    );
    toast(raisetoast);
  };

  const colonToUnicode = (message) => {
    return message.replace(/:[A-Za-z0-9_+-]+:/g, (x) => {
      x = x.replace(/:/g, "");
      let emoji = emojiIndex.emojis[x];
      if (typeof emoji !== "undefined") {
        let unicode = emoji.native;
        if (typeof unicode !== "undefined") {
          return unicode;
        }
      }
      x = ":" + x + ":";
      return x;
    });
  };

  const addEmoji = (e) => {
    const newMesage = colonToUnicode(`${text} ${e.colons}`);
    setText(newMesage);
  };

  const validMessage = (m) => m && m.replace(/\s/g, "").length;

  const handleImage = (e) => {
    if (e.target.files[0]) {
      const maxAllowedSize = 1 * 1024 * 1024;
      if (e.target.files[0].size < maxAllowedSize) {
        setImage(e.target.files[0]);
        const imageSrc = URL.createObjectURL(e.target.files[0]);
        const imagePreview = document.getElementById("preview");
        imagePreview.src = imageSrc;
        imagePreview.style.display = "block";
      } else {
        notification("Image Size Should Be Less Than 1 MB");
      }
    }
  };

  const removeImage = () => {
    const imagePreview = document.getElementById("preview");
    imagePreview.src = "";
    imagePreview.style.display = "none";
    setImage(null);
  };

  const handleImageUpload = (msg) => {
    setProgress(20);
    const imageName = user + Date.now();
    const uploadTask = storage.ref(`images/${imageName}.jpg`).put(image);
    uploadTask.on(
      "state_change",
      (snapshot) => {
        const prog = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setProgress(prog);
      },
      (error) => {
        console.log("Some Error Ocuured while Posting");
      },
      () => {
        storage
          .ref("images")
          .child(`${imageName}.jpg`)
          .getDownloadURL()
          .then((photoUrl) => {
            send(msg, photoUrl, chatIndex);
            const imagePreview = document.getElementById("preview");
            imagePreview.src = "";
            imagePreview.style.display = "none";
            setImage(null);
            setText("");
            setProgress(0);
          });
      }
    );
  };

  const sendMessage = (msg) => {
    if (image) handleImageUpload(msg);
    else {
      if (validMessage(msg)) {
        send(msg, null, chatIndex);
        const imagePreview = document.getElementById("preview");
        imagePreview.style.display = "none";
        setProgress(0);
        setText("");
      } else notification("Cannot Send An Empty Message.");
    }
  };

  const handleTyping = (status) => {
    if (status) userIsTyping(chatIndex, true);
    else userIsTyping(chatIndex, false);
  };

  const userClickedInput = () => {
    read(chatIndex);
  };

  const userTyping = (e) => {
    handleTyping(e.target.value.length);
    if (e.shiftKey) if (e.keyCode === 13) sendMessage(e.target.value);
  };

  return (
    <div className="createMessageBox">
      {emojiPicker && (
        <Picker
          style={{
            position: "absolute",
            bottom: "5rem",
            left: "1rem",
            maxWidth: "90%",
          }}
          title="Pick Your Emoji"
          set="facebook"
          emoji="thumbsup"
          onSelect={(e) => addEmoji(e)}
        />
      )}

      <div className="create__message">
        <div className="emojis">
          <button
            className="emoji-pick"
            onClick={() => showEmojiPicker(!emojiPicker)}
          >
            <img src={EmojiIcon} alt="pick emoji" />
          </button>
        </div>
        <textarea
          placeholder="Your Message ..."
          onKeyUp={(e) => userTyping(e)}
          onFocus={userClickedInput}
          onChange={(e) => setText(e.target.value)}
          value={text}
          className="message__text"
          id="textBox"
        />

        <div className="image__up">
         {progress !==0 && <LinearProgress variant="buffer" valueBuffer={25} value={progress} />}
          <div className="options">
            {progress === 0 && (
              <label htmlFor="image">
                <i className="fa fa-camera addImage"></i>
              </label>
            )}
            <input
              id="image"
              hidden
              type="file"
              accept="image/*"
              onChange={handleImage}
            />
            <div className="withTooltip">
              <div className="tooltip" style={{ width: "7.5rem" }}>
                {tooltip("Click to Remove")}
              </div>
              <img id="preview" src="" alt="selected" onClick={removeImage} />
            </div>
          </div>
        </div>

        {progress === 0 ? (
          <div className="withTooltip">
            <div className="tooltip" style={{ width: "6rem" }}>
              {tooltip("Shift + Enter")}
            </div>
            <button className="message__send" onClick={() => sendMessage(text)}>
              <i className="fa fa-location-arrow"></i>
            </button>
          </div>
        ) : (
          <CircularProgress />
        )}
      </div>
    </div>
  );
};

export default CreateMessage;
